import {
  SUPER_ADMIN_LOGIN,
  SUPER_ADMIN_LOGOUT,
  INSTITUTION_LOGOUT_URL,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

export const superAdminLogin = async (loginData) => {
  try {
    const response = await fetch(SUPER_ADMIN_LOGIN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};

export const superAdminLogout = async () => {
  try {
    const token = Cookies.get("admin_token");
    const response = await fetch(SUPER_ADMIN_LOGOUT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `${token}` } : {}),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error during logout:", error);
    throw error;
  }
};

export const institutionLogout = async () => {
  try {
    const token = Cookies.get("institution_token");
    const response = await fetch(INSTITUTION_LOGOUT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: ` ${token}` } : {}),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error during institution logout:", error);
    throw error;
  }
};
